import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthHelper } from 'src/helper/auth-helper';
import { CommonApiService } from 'src/helper/common-api.service';
import { StaticDataApiService } from 'src/helper/static-data.service';
import { AdminService } from 'src/pages/admin/admin.service';
import { AuthService } from 'src/pages/admin/login/auth.service';

@Component({
  selector: 'app-itim-book',
  templateUrl: './itim-book.component.html',
  styleUrls: ['./itim-book.component.css'],
})
export class ItimBookComponent implements OnInit {
  booklinkdetails: any;
  bookdetails: any;
  isseminar: boolean = false;
  isadmin: boolean = false;
  Rtoken: any;
  Email: any;
  rLink: any;
  courseid: any;
  isEnrolled: boolean = false;
  isauth: any;
  courseId: any;
  courseData: any;
  apiUrl = environment.blobUrl;
  constructor(
    private commonApiService: CommonApiService,
    private adminservice: AdminService,
    private route: ActivatedRoute,
    private staticdata: StaticDataApiService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.isauth = this.authService.isAuthenticated;
    this.route.params.subscribe((param: Params) => {
      let is_seminar = localStorage.getItem('isseminar');
      let is_admin = AuthHelper.UserDetails.IsAdmin;
      if (
        is_seminar == 'true' ||
        is_admin == 'true' ||
        param['bookid'] == 'Christianity101'
      ) {
        this.isseminar = true;
      }
      this.courseId = param['id'];

      this.commonApiService
        .getPromiseResponse({
          apiName: `/api/courses/${this.courseId}`,
          methodType: 'get',
          parameterObject: null,
        })
        .then((result: any) => {
          this.courseData = result;
          console.log(this.courseData.isSeminarRequired);
          if (this.courseData.name == 'Christianity 101') {
            this.isseminar = true;
          }
          this.bookdetails = JSON.parse(this.courseData.detailjson);
        })
        .catch((q) => { });

      //this.courseid = this.bookdetails?.isEnrollOnlineText.split("/");

      this.courseid = this.courseId;
    });

    if (
      this.bookdetails?.isEnrollOnlineText != '' &&
      this.authService.isAuthenticated
    ) {
      this.adminservice
        .getIsEnroll(
          AuthHelper.UserDetails.AccountId,
          this.courseid[this.courseid.length - 1]
        )
        .then((result: any) => {
          this.isEnrolled = result.isEnrolled;
        })
        .catch((err: any) => { });
    }
  }

  enrollOnline(data: any) {
    if (this.authService.isAuthenticated) {
      this.adminservice
        .getnewToken(AuthHelper.UserDetails.AccountId)
        .then((result: any) => {
          this.rLink =
            environment.enrollOnline +
            data +
            '?Rtoken=' +
            result.rToken +
            '&' +
            'Email=' +
            localStorage.getItem('userName') +
            '&' +
            'IsEnrolled=' +
            this.isEnrolled;
          window.location.href = this.rLink;
        })
        .catch((err: any) => { });
    }
  }
  redirectSeminar() {
    this.router.navigate(['/session']);
  }
}
